import { render, staticRenderFns } from "./MobFullQuoteHeader.vue?vue&type=template&id=5f55581c&scoped=true"
import script from "./MobFullQuoteHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MobFullQuoteHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobFullQuoteHeader.vue?vue&type=style&index=0&id=5f55581c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f55581c",
  null
  
)

export default component.exports